import {useUser} from "../../../Context/UserContext";
import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import EmptyLine from "../../EmptyLine";
import ResultTable from "../../Table/ResultTable";
import ResultHeader from "../../Table/ResultHeader";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultRow from "../../Table/ResultRow";
import HecRasHelper from "../../../Helpers/HecRasHelper";
import ResultBody from "../../Table/ResultBody";
import ResultBodyCell from "../../Table/ResultBodyCell";
import ResultView from "../../V2/ResultView";

export function FL5({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.FL5_FL7.error_id: {
            return (
                <>
                    <ResultText>
                        Normal Depth Slope is not within the defined range {settings?.thresholds?.normal_depth_slope_min} - {settings?.thresholds?.normal_depth_slope_max} at the highlighted profiles. The channel slope between the two most downstream cross sections ({row?.ds_chn?.toFixed(2)} ft apart) is {row?.ds_chn_slope?.toFixed(4)}.
                    </ResultText>
                    <EmptyLine />
                    <ResultTable data={row}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(15)}}>Profile</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(20), textAlign: 'end'}}>Downstream</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data[0]?.normal_depths?.map(r => {
                                    let is_not_red = (settings?.thresholds?.normal_depth_slope_min <= r?.downstream) && (r?.downstream <= settings?.thresholds?.normal_depth_slope_max)
                                    if(r?.name !== 'Normal Depth S')
                                       is_not_red = true
                                    return (
                                        <ResultRow>
                                            <ResultBodyCell style={{width: HecRasHelper.getWidth(15)}}>{r.profile}</ResultBodyCell>
                                            <ResultHeaderCell style={{width: HecRasHelper.getWidth(20), textAlign: 'end'}}>
                                                {r?.name} = <span style={{color: is_not_red ? '' : 'red' }}>{r?.downstream}</span>
                                            </ResultHeaderCell>
                                        </ResultRow>
                                    )
                                })
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
    }
}